"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const react_router_1 = require("react-router");
const Auth_1 = require("../../actions/Auth");
const VerifyPage = () => {
    const { t } = (0, react_i18next_1.useTranslation)('auth');
    const dispatch = (0, react_redux_1.useDispatch)();
    const { token } = (0, react_router_1.useParams)();
    const [status, setStatus] = react_1.default.useState('In Progress');
    const tokenVerified = react_1.default.useCallback((response) => {
        if (response &&
            (response.status === 'Confirmed' ||
                response.status === 'In Progress' ||
                response.status === 'NotFound' ||
                response.status === 'Error')) {
            setStatus(response.status);
        }
        else {
            setStatus('Error');
        }
    }, []);
    react_1.default.useEffect(() => {
        if (token) {
            dispatch((0, Auth_1.startConfirmUser)({ token }, tokenVerified));
        }
    }, [dispatch, token, tokenVerified]);
    const getStatusMessage = react_1.default.useCallback(() => {
        switch (status) {
            case 'In Progress':
                return 'auth:ConfirmationTokenConfirming';
            case 'Confirmed':
                return 'auth:ConfirmationTokenConfirmed';
            case 'NotFound':
                return 'auth:ConfirmationTokenNotFound';
            default:
                return 'auth:ConfirmationTokenError';
        }
    }, [status]);
    return (react_1.default.createElement("div", { className: "apptr__form apptr__form-auth apptr__form__label-standalone" },
        react_1.default.createElement("p", { className: "apptr__form__label-standalone" }, t(getStatusMessage())),
        status !== 'In Progress' && (react_1.default.createElement("p", { className: "apptr__form__label-standalone" },
            react_1.default.createElement(react_router_1.Link, { to: "/" }, t('auth:BackToHomePage'))))));
};
exports.default = VerifyPage;
//# sourceMappingURL=VerifyPage.js.map